module.exports = __webpack_public_path__ + "static/media/radio1.77e40741.svg";